<bspk-form-field data-bspk="dropdown-field"
                 [controlId]="controlId()"
                 [errorMessage]="errorMessage() || errorState()"
                 [helperText]="helperText()"
                 [label]="label()"
                 [required]="required()">

  <bspk-dropdown [aria-label]="label()"
                 [disabled]="disabled()"
                 [id]="controlId()"
                 [invalid]="invalid() || !!errorState()"
                 [itemCount]="itemCount()"
                 [options]="options()"
                 [placeholder]="placeholder()"
                 [readOnly]="readOnly()"
                 [size]="size()"
                 [value]="value() ? [value()] : []"
                 (blur)="handleBlur()"
                 (valueChange)="handleChange($event)"
  />
</bspk-form-field>
